<template lang="pug">
  .school-tab(v-if='school')
    .section.row.school-section(v-if='isAdmin')
      h4.text-big.dark-gray
        | {{ $t('profile.schoolTab.school') }}
      k-select.select.text-normal(
        name='school'
        :preselectedOption='school.id'
        keyName='value'
        :options='getSchoolsArray'
        withBorder
        @selectOption='getSchoolInfo'
      )
    .gray-section(:class='!isAdmin && "m-top-2"')
      .school-header.row.middle.relative
        img.school-img(:src='school.avatar || defaultSchool' :alt='school.name')
        .column.m4-left-11.width-100
          h3.school-name.text-xbig.black.bold.word-break.ellipsis
            | {{ school.name }}
          .row.middle.m4-top-12
            simple-svg.blue-icon.m4-right-1.location-icon(:filepath='locationIcon' :width='"20px"' :height='"20px"')
            span.address.text-big.blue.word-break.ellipsis
              | {{ school.address }}
    .section.row
      h4.text-big.dark-gray.self-baseline
        | {{ $t('profile.schoolTab.bioLabel') }}
      trial-disable-field
        p.text-big.black.m-left-1
          | {{ school.bio }}
    .section.row.relative
      h4.text-big.dark-gray
        | {{ $t('profile.schoolTab.team') }}
      trial-disable-field
        avatars-list.m-left-1(
          :elementsList='school.schoolTeam'
          :usersType='teamID'
        )
    .section.row
      h4.text-big.dark-gray.title.self-baseline
        | {{ $t('profile.schoolTab.levels') }}
      trial-disable-field
        .column.m-left-1
          span.text-big.black.m-bottom-1(v-for='level in school.impartedLevels' :key='level')
            | {{ getEducationalLevelName(level) }}
    .section.row
      h4.text-big.dark-gray
        | {{ $t('profile.schoolTab.mail') }}
      trial-disable-field
        p.text-big.black.m-left-1
          | {{ school.email }}
    .section.row
      h4.text-big.dark-gray.title
        | {{ $t('profile.schoolTab.students') }}
      trial-disable-field
        p.text-big.black.m-left-1.self-baseline
          | {{ getStudentsRangeText }}
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import KSelect from '../KSelect'
import AvatarsList from './AvatarsList'
import TrialDisableField from './TrialDisableField'

import locationIcon from '@/assets/ic_location.svg'
import defaultSchool from '@/assets/ic_school.svg'

import { studentsRange, managersID, teamID, userPrimaryRoles } from '../../utils/constants'
import { toLowerCamelCase } from '../../utils/string'
import userRole from '../../mixins/userRole'
import { i18n } from '../../main'

export default {
  mixins: [userRole],
  components: { KSelect, AvatarsList, TrialDisableField },
  data() {
    return {
      locationIcon,
      defaultSchool,
      managersID,
      teamID,
      succesfulRequest: false,
      userPrimaryRoles
    }
  },
  async created() {
    const { resend } = this.$route.query
    if (resend) {
      this.showElement({ element: 'fullPageLoader' })
      const success = await this.resendInvitation({
        schoolId: this.$route.query.schoolId,
        id: this.$route.query.userId
      })
      this.hideElement({ element: 'fullPageLoader' })
      if (success) {
        this.showElement({
          element: 'successModal',
          props: { title: i18n.t('trialInvite.invitationResendTitle') }
        })
      } else {
        this.$notify({
          group: 'custom-toast',
          text: i18n.t('token.requestInvitationResendError'),
          type: 'error'
        })
      }
    }
  },
  computed: {
    ...mapState({
      educationalLevels: state => state.profile.educationalLevels
    }),
    ...mapGetters({
      schoolGroup: 'getSchoolGroup',
      school: 'getSchool'
    }),
    getSchoolsArray() {
      return this.schoolGroup.schools.map(school => ({ value: school.id, label: school.name }))
    },
    getStudentsRangeText() {
      const schoolRange = studentsRange.find(range => range.id === this.school.studentsRange)
      return schoolRange ? schoolRange.label : ''
    }
  },
  methods: {
    ...mapActions([
      'hydrateSchoolInfo',
      'showElement',
      'hideElement',
      'resendInvitation'
    ]),
    getEducationalLevelName(id) {
      const level = this.educationalLevels.find(edLevel => edLevel.id === id)
      return level ? this.$t(`profile.educationalLevel.${toLowerCamelCase(level.name)}`) : ''
    },
    async getSchoolInfo(_, schoolId) {
      if (schoolId !== this.school.id || !this.succesfulRequest) {
        this.showElement({ element: 'fullPageLoader' })
        this.succesfulRequest = await this.hydrateSchoolInfo(schoolId)
        this.hideElement({ element: 'fullPageLoader' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';

.section {
  align-items: center;
  display: grid;
  grid-template-columns: 190px 590px;
  padding: 48px 52px;

  &:not(:last-child) {
    border-bottom: 1px solid $light-gray;
  }

  .img-container {
    align-items: center;
    max-height: 24px;
  }
}

.school-section {
  height: 137px;
}

.select {
  max-height: 40px;
  max-width: 344px;
  width: 100%;
}

.title {
  max-width: 106px;
}

.gray-section {
  background-color: $light-gray;
  height: 172px;
  margin-bottom: 76px;
  position: relative;
  width: 100%;
}

.school-header {
  padding: 0 52px;
  position: relative;
  top: 48px;
}

.school-img {
  background-color: $white;
  box-shadow: 0 2px 8px 0 $shadow-gray;
  height: 200px;
  max-width: 200px;
  padding: 32px;
}

.school-name {
  margin-bottom: 4px;
  width: 536px;
}

.location-icon {
  height: 20px;
}

.address {
  width: 512px;
}
</style>
